import React, { useEffect, useRef, useState, useContext } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import { HomeworkSvg } from "../svg/svgs";
import useOnClick from '../components/common/ClosePopUp';
import axios from "axios";
import loadingSpin from '../images/loadingSpin.gif';
import { animated, useSpring } from "react-spring";
import Card from '../components/common/Card';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyContent from "../components/common/EmptyContent";
import SecureCard from "../components/SecureCard";
import { DataContext } from "../context/DataContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Payments = () => {
    const [displayDropdown, setDisplayDropdown] = useState(false);
    const [clickedDropdown, setClickedDropdown] = useState("All Homework");
    const [noHomework, setNoHomework] = useState(false);
    const [newHomework, setNewHomework] = useState(true);
    const [fetchedSecurePickup, setFetchedSecurePickup] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [ fetchError, setFetchError ] = useState(false);

    const dataContext = useContext(DataContext)
    // console.log(JSON.parse(localStorage.getItem('studentInfo'))[0].phonenumber)
    // console.log(JSON.parse(localStorage.getItem('subSchoolData')).idx)
    const host = dataContext.host
    console.log(host)

    useEffect(() => {
        getPayments();
        return () => {}
    }, [])

    const getPayments = async () => {
        try {
            setLoading(true)
            const { data } = await axios.get(`https://devapi.edves.net/bills-assets/public/v1/getParentChild/${JSON.parse(localStorage.getItem('studentInfo'))[0].phonenumber}/${JSON.parse(localStorage.getItem('subSchoolData')).idx}/${host}`);
            console.log(data.data.Message, "data message");
            if (data.data.status) {
                setFetchedSecurePickup(data.data.Message)
                setLoading(false)
            } else {
                setLoading(false);
                setErrorMessage(data.data.Message)
            }
        } catch (error) {
            setLoading(false);
            setFetchError(true)
        }
    }
    const processgenratePassword = async () => {
        try {
            setLoading(true)
            const { data } = await axios.get(`https://devapi.edves.net/bills-assets/public/v1/geratePickupsecureCode/${JSON.parse(localStorage.getItem('studentInfo'))[0].phonenumber}/${JSON.parse(localStorage.getItem('subSchoolData')).idx}/${host}`);
            if (data.status === true) {
              toast.success(data.data.Message, {autoClose: 3000,
                hideProgressBar: false,} )
                setTimeout(() =>  window.location.reload(), 3000);
                setLoading(false)
                
            } else {
                setLoading(false);
                setErrorMessage(data.message)
                // console.log(data.message)
            }
        } catch (error) {
            setLoading(false);
            setFetchError(true)
        }
    }


    const showNoHomework = classNames({
        "flex justify-center w-full mt-16": true,
        "hidden": !noHomework 
    });
    const displayHomeworkContent = (item) => {
        // alert(item);
        setClickedDropdown(item);
        setDisplayDropdown(!displayDropdown);
        setNoHomework(false);
        // if (item === "New Homework") setNewHomework(true);
        getPayments(item);
    };
    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1"> Secure Pickup </span>
        </>
    );
    const pageSvg = () => (
        <>
            <HomeworkSvg />
        </>
    )

    const ref = useRef();

    useOnClick(ref, () => setDisplayDropdown(false));

    const transitionStyles = useSpring({
        to: [
        { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 700 }
    });

    return (
        <>
            <animated.div style={transitionStyles} className="px-4 sm:flex sm:-mt-2 sm:px-0">
            <ToastContainer />
                <div className="w-full md:w-2/3 sm:pl-2">
                    <PageNav Heading={Heading} PageSvg={pageSvg} />
                    <div className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer" style={{maxWidth: 140, marginTop: 15, backgroundColor: "#fff", fontSize: 16}} onClick={()=> processgenratePassword()}>generate code</div>
                    <div className="pt-6 w-full">
                        
                        {loading ? 
                        <div className='flex justify-center w-full h-full my-24'>
                            <img src={loadingSpin} alt='loading...' />
                        </div> : 
                        <>
                            {fetchedSecurePickup.length < 1 && 
                                <div className={showNoHomework}>
                                    <EmptyContent message='No Secure Code' moreMessage='You can always generate a secure code above' />
                                </div>
                            }
                            {newHomework && fetchedSecurePickup.length > 0 &&
                                <div className="mt-4">
                                    <SecureCard
                                        arrayDataSets={fetchedSecurePickup}
                                    />
                                </div>
                            }
                            {
                                fetchError &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! Something Went Wrong
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                    Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div> 
                            }
                            {errorMessage &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! {errorMessage}
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            }
                            
                        </>
                    }
                    </div>
                </div>
            </animated.div>
        </>
    )
}

export default Payments;